import axiosInstance from "../utils/axiosInstance";
import { SavedPromptsMap } from "./savedPromptsTypes";

interface UpdateSavedPromptsApiResponse {
  success: boolean;
  data?: {
    prompts?: SavedPromptsMap;
  };
}

export const updateSavedPrompts = async (
  prompts: SavedPromptsMap,
): Promise<SavedPromptsMap> => {
  try {
    const response = await axiosInstance.put<UpdateSavedPromptsApiResponse>("/saved-prompts", {
      prompts,
    });
    return response.data.data?.prompts || {};
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to save prompts.");
  }
};
